import { memo, useRef, useState } from 'react'
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse } from '@mui/material'
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { ArrowDropDown, ArrowDropUp, Close } from '@mui/icons-material';
import styles from "./styles/filterList.module.css"
import { ls } from "../variables";
import { useStateValue } from '../Hooks/stateProvider';
import { alert } from '../utils/sweetAlert';

const FilterList = memo(({ handleOpen, open, openNestedList, setOpenNestedList, trackerPageFetch, moduleType, guidanceTypeOptions, fetchData,initialUpload = false, multiSelect }) => {
    const [expanded, setExpanded] = useState("")
    const [disableRemarks, setDisableRemarks] = useState(false)
    const [guidanceArr, setGuidanceArr] = useState([])
    const userType = ls.get("userType");
    const [{ pmsOpenNestedList }, dispatch] = useStateValue();
    const overlayRef = useRef(null);
    // Function to handle click outside of the overlay
    const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            handleOpen(false) // Call onClose function passed as prop
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        // Remove click event listener when the component unmounts
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    let dataLists;

    if (moduleType.toUpperCase() == 'CMM') {
        dataLists = [
            {
                name: "CMM Type",
                nestedLists: ["Compliance Reporting Category 1", "Compliance Reporting Category 2"],
                localList: "localCMMTypeData",
            },
            {
                name: "Remarks",
                nestedLists: ["Compliant", "Partially Compliant","Compliant(No Change)", "Not Compliant","Not Applicable"],
                localList: "localRemarksData",

            },
            {
                name: "Status",
                nestedLists: userType == 'SEBI' ? [
                    "open (sebi)",
                    "closed"
                ]:[
                    "open"
                ],
                localList: "localStatusData",
            },
        ]
    }
    else {
        dataLists = [
            {
                name: "Guidance Type",
                nestedLists: guidanceTypeOptions,
                localList: "localGuidanceData"
            },
            {
                name: "Status",
                nestedLists:  userType == 'SEBI' ? [
                    "open (sebi)",
                    "closed"
                ] : [
                    "open",
                    "pending"
                ],
                localList: "localStatusData",
            },
        ]
    }

    const handleToggle = (key, category) => () => {
        let currentIndex;
        let newChecked = []
        currentIndex = openNestedList[category].indexOf(key);
        newChecked = [...openNestedList[category]];
        if (category == "localCMMTypeData") {
            if (key == "Investors Complaints" && currentIndex == -1) {

                setDisableRemarks(true)
            }
            else {
                setDisableRemarks(false)
            }
        }
        if (currentIndex === -1) {
            if (category === "localCMMTypeData") {
                newChecked = [key];
            } else {
                newChecked.push(key);
            }
        } else {
            newChecked.splice(currentIndex, 1);
        }
        if (key == "Investors Complaints" && currentIndex == -1) {
            setOpenNestedList({ ...openNestedList, [category]: newChecked, "localRemarksData": [] });
        }
        else {
            setOpenNestedList({ ...openNestedList, [category]: newChecked });

        }
        return;
    };
    const handleApply = (handleObj) => {
        setGuidanceArr(guidanceTypeOptions);
        dispatch({ type: "SET_OpenNestedList", pmsOpenNestedList: handleObj });
        dispatch({ type: "SET_filter", setFilter: true });
        if (moduleType.toUpperCase() == 'CMM') {
            if (openNestedList["localCMMTypeData"].length == 0) {
                return alert("Please Select CMM Type", "", "warning")
            }
        }
        // keeping if condition for greennote and dashboard
        if (trackerPageFetch) {
            trackerPageFetch(false);
        }
        else {
            fetchData(handleObj);
        }
        return;
    }

    useEffect(() => {
        setOpenNestedList(pmsOpenNestedList)
    }, [])

    const handelNestedLists = (title) => {
        if (expanded === title) {
            setExpanded("");
        } else {
            setExpanded(title);
        }
        return;
    };

    const handleClear = (userType) => {
        if (userType == 'SEBI') {
            fetchData({
                "localCMMTypeData": ["Compliance Reporting Category 1"],
                "localRemarksData": [],
                "localStatusData": ["open (sebi)"],
                "localGuidanceData": [],
                "localQuarterData": ['Q1'],
                "localYearData": ['2024'],
            })
            handleApply({
                "localCMMTypeData": ["Compliance Reporting Category 1"],
                "localRemarksData": [],
                "localStatusData": ["open (sebi)"],
                "localGuidanceData": [],
                "localQuarterData": ['Q1'],
                "localYearData": ['2024'],
            })
        }
        else{
            fetchData({
                "localCMMTypeData": ["Compliance Reporting Category 1"],
                "localRemarksData": [],
                "localStatusData": ["open"],
                "localGuidanceData": []
            })
            handleApply({
                "localCMMTypeData": ["Compliance Reporting Category 1"],
                "localRemarksData": [],
                "localStatusData": ["open"],
                "localGuidanceData": []
            })
        }
        handleOpen(false)
    }

    return (
        <>
            {
                open &&
                <div ref={overlayRef} style={{ backgroundColor: "#F3F3F3" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", padding: "0.5rem 1rem 0rem 0" }}>
                        <Close fontSize='medium' htmlColor='#495057' style={{ cursor: "pointer" }} onClick={() => handleOpen(false)} />
                    </div>
                    <div className={styles.noscroll} style={{ maxHeight: "280px", overflow: "scroll" }}>

                        {
                            dataLists.map((ele, index) => {
                                return (
                                    <List key={index} sx={{ padding: 0 }}>
                                        <ListItem divider sx={{ "& .MuiListItemButton-root": { "height": "2rem", padding: "0rem 0rem 0rem 1rem", borderRadius: "1rem", } }}>
                                            <ListItemButton onClick={() => handelNestedLists(ele.name)} >
                                                <ListItemText primary={ele.name} />
                                                <ListItemIcon sx={{ paddingLeft: "3rem", color: "#153046" }}  >
                                                    {expanded == ele.name ? <ArrowDropUp fontSize='large' htmlColor='#153046 ' /> : <ArrowDropDown fontSize='large' htmlColor='#153046' onClick={() => handelNestedLists(ele.name)} />}
                                                </ListItemIcon>

                                            </ListItemButton>
                                        </ListItem>
                                        <Collapse in={expanded == ele.name}>
                                            <List sx={{ paddingBlock: "0", maxHeight: "250px", overflowY: "scroll" }}>
                                                {ele.nestedLists?.map((key, i) => {
                                                    const labelId = `checkbox-list-label-${key}`;
                                                    return (<ListItem divider sx={{ paddingBlock: "0" }} key={i}>
                                                        <ListItemButton disabled={ele.name == "Remarks" && disableRemarks} onClick={handleToggle(key, ele.localList)} sx={{ "height": "fit-content", marginLeft: '35px', padding: 0, borderRadius: "1rem", marginBlock: "0.2rem" }}>
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    edge="start"
                                                                    checked={openNestedList[ele.localList]?.indexOf(key) !== -1}
                                                                    tabIndex={-1}
                                                                    disableRipple
                                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                                />
                                                            </ListItemIcon>
                                                            <ListItemText id={labelId} primary={key} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                    );
                                                })}
                                            </List>
                                        </Collapse>
                                    </List>
                                );
                            })
                        }

                    </div>

                    <div style={{ margin: "0.5rem", display: "flex", justifyContent: "space-evenly" }}>
                        <Button variant="contained" size='small'
                            onClick={() => {
                                handleApply(openNestedList);
                                handleOpen();
                            }} sx={{ width: "40%", backgroundColor: "#154063", border: "none", fontSize: { xs: ".5rem", md: "0.6rem", lg: "0.9rem" }, "&:hover": { backgroundColor: "#154063", border: "none" } }}>Apply Filter</Button>
                        {!initialUpload && <Button variant="outlined" size='small'
                            onClick={() => {
                                handleClear(userType);
                            }} sx={{ width: "40%", color: "#FFFFFF", backgroundColor: "#E74343", fontSize: { xs: ".5rem", md: "0.6rem", lg: "0.9rem" }, border: "none", "&:hover": { backgroundColor: "#E74343", border: "none" } }}>Clear</Button>}
                    </div>
                </div>
            }
        </>
    );
})

export default FilterList